
import { defineComponent } from 'vue';
import VTable from '@/components/vendor/basic/table/VTable.vue';
import VTableHeader from '@/components/vendor/basic/table/VTableHeader.vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VTableBody from '@/components/vendor/basic/table/VTableBody.vue';
import VLoader from '@/components/vendor/VLoader.vue';
import useCapabilities from '@/resources/capabilities';
import Media from '@/api/objects/Media';
import TheAdminResourcesUpload
  from '@/views/administrator/resources/parts/TheAdminResourcesUpload.vue';
import TheAdminResourcesShowModal
  from '@/views/administrator/resources/parts/TheAdminResourcesShowModal.vue';

export default defineComponent({
  // TODO: This could be refactored to be used for any role
  name: 'TheAdminResourcesList',
  components: {
    TheAdminResourcesShowModal,
    TheAdminResourcesUpload,
    VLoader,
    VTableBody,
    VButton,
    VTableHeader,
    VTable,
  },
  props: {
    media: {
      type: Array,
      required: false,
    },
    status: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  data() {
    return {
      showAddMedia: false,
      modalToShow: null,
      currentMedia: null as null | Media,
    };
  },
  methods: {
    mediaConfirm() {
      this.showAddMedia = false;
      this.$emit('refresh-media');
    },
  },
});
